import styled from "styled-components";

const HomeContainer = styled.div`
  width: 100%;
  height: calc(100vh - 105px); // Ajusta según tu navbar
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.contentBackground};
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 5px;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    height: calc(100vh - 95px);
    padding: 4px;
  }

  @media (max-width: 768px) {
    height: calc(100vh - 85px);
    padding: 3px;
    border-radius: 4px;
  }

  @media (max-width: 480px) {
    height: calc(100vh - 75px);
    padding: 2px;
    border-radius: 2px;
  }
`;

const DivContainer = ({ children }) => {
  return (
    <div className="div-container">
      <HomeContainer>{children}</HomeContainer>
    </div>
  );
};

export default DivContainer;